import React from "react";

import "./SeaDawgMark.scss"

function SeaDawgMark() {
    return (
        <div className="water_mark_container">
            <div className="water_mark_lines line_one"></div>
            <p className="water_mark">sea.dawg.in</p>
            <div className="water_mark_lines line_two"></div>
        </div>
    );
}

export default SeaDawgMark;
